import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  focus(event) {
    const id = Number(event.currentTarget.dataset.officeId);

    window.dispatchEvent(
      new CustomEvent("nova:offices:focusOffice", { detail: { id } })
    );
  }
}
